import { Icon } from '../../components/Icon';
import { PALETTE, SERVICE_LABEL, tint, useStore } from '../../state/store';
import type { ServiceType } from '../../data/types';

export function ColorsPage() {
  const s = useStore();
  const snap = s.snapshot;
  const swatches = (sel: string, pick: (c: string) => void, label: string) => (
    <div className="row wrap" style={{ gap: 6 }} role="radiogroup" aria-label={`Color de ${label}`}>
      {PALETTE.map(c => (
        <button key={c} type="button" role="radio" aria-checked={c === sel} aria-label={c} onClick={() => pick(c)}
          style={{ width: 30, height: 30, borderRadius: 8, background: c, border: c === sel ? '3px solid #1F1F21' : '2px solid #fff', boxShadow: '0 0 0 1px #D6D6D3', cursor: 'pointer', padding: 0 }} />
      ))}
    </div>
  );
  return (
    <div className="content">
      <header><div className="eyebrow">Agenda inteligente</div><h1 className="h1">Colores de la agenda</h1></header>
      <div className="row wrap" style={{ alignItems: 'flex-start', gap: 16 }}>
        <section className="w" style={{ flex: '1 1 300px' }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>¿Cómo quieres colorear la agenda?</h2>
          {([['team', 'Por equipo', 'Cada equipo con su color. Ves de un vistazo quién va dónde.'], ['service', 'Por tipo de servicio', 'Regular, profunda, oficina… Ves qué tipo de día tienes.']] as const).map(([v, t, d]) => (
            <label key={v} className="row" style={{ alignItems: 'flex-start', padding: 12, borderRadius: 12, border: s.colorBy === v ? '2px solid #FAAF3B' : '1px solid #E2E2DF', background: s.colorBy === v ? '#FFFBF2' : '#fff', cursor: 'pointer' }}>
              <input type="radio" name="colorBy" checked={s.colorBy === v} onChange={() => s.setColorBy(v)} />
              <span><b>{t}</b><br /><span className="muted" style={{ fontSize: 13 }}>{d}</span></span>
            </label>
          ))}
          <div style={{ borderTop: '1px solid #F0EFEB', paddingTop: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <span className="muted" style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>Vista previa</span>
            {snap.visits.filter(v => v.date === snap.today).slice(1, 4).map(v => {
              const c = s.colorFor(v);
              return (
                <div key={v.uid} className="row" style={{ background: tint(c), borderLeft: `5px solid ${c}`, borderRadius: 8, padding: '8px 10px', fontSize: 13 }}>
                  <Icon name={v.service} color={c} size={15} />
                  <b>{snap.clients.find(x => x.uid === v.clientUid)?.name}</b>
                  <span className="muted">· Equipo {v.teamId} · {SERVICE_LABEL[v.service]}</span>
                </div>
              );
            })}
            <span className="muted" style={{ fontSize: 12 }}>El estado nunca depende del color: se marca con ✓, % de avance o “!”.</span>
          </div>
        </section>
        <section className="w" style={{ flex: '999 1 560px' }}>
          <h2 style={{ margin: 0, fontSize: 16 }}>Colores por equipo</h2>
          {snap.teams.map(t => (
            <div key={t.id} className="row wrap" style={{ justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #F0EFEB' }}>
              <div className="row"><span style={{ width: 18, height: 18, borderRadius: 5, background: t.color }} /><div><b>{t.name}</b><div className="muted" style={{ fontSize: 12 }}>{t.members.map(m => m.name.split(' ')[0]).join(' · ')}</div></div></div>
              {swatches(t.color, c => s.setTeamColor(t.id, c), t.name)}
            </div>
          ))}
          <h2 style={{ margin: '14px 0 0', fontSize: 16 }}>Colores por tipo de servicio</h2>
          {(Object.keys(SERVICE_LABEL) as ServiceType[]).map(sv => (
            <div key={sv} className="row wrap" style={{ justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #F0EFEB' }}>
              <div className="row"><Icon name={sv} color={s.serviceColors[sv]} size={18} /><b>{SERVICE_LABEL[sv]}</b></div>
              {swatches(s.serviceColors[sv], c => s.setServiceColor(sv, c), SERVICE_LABEL[sv])}
            </div>
          ))}
          <div className="row"><button type="button" className="btn pri" onClick={() => { s.notify('Colores guardados en este navegador. En producción se guardan por empresa.'); s.go('agenda'); }}>Guardar</button></div>
        </section>
      </div>
    </div>
  );
}
